import {getFixtures} from "./api/fixtures"
import {getFeaturedLeagues, getLeagues} from "./api/league"
import {ClientFactory} from "./eventSearch"
import {LeagueResponse} from "../types/league"
import {FixtureResponse} from "../types/fixture"

/** How many matches a competition is shown at a time */
const UPCOMING_FIXTURES = 20

/**
 * Competitions and their fixtures.
 *
 * Both come from the football data provider, which is the one that carries competitions, crests and
 * calendars. The prediction provider is only asked for the analysis of a match, once one is picked.
 */

/** The competitions put forward before anything is typed, crests included */
export const fetchFeaturedLeagues = async (newClient: ClientFactory): Promise<LeagueResponse[]> => {
    const response = await getFeaturedLeagues(await newClient())
    return response?.response || []
}

/** Competitions whose name matches what was typed */
export const searchLeagues = async (newClient: ClientFactory, search: string): Promise<LeagueResponse[]> => {
    const response = await getLeagues(await newClient(), {search})
    return response?.response || []
}

/** The matches a competition still has to play, soonest first */
export const fetchLeagueFixtures = async (newClient: ClientFactory, leagueId: number): Promise<FixtureResponse[]> => {
    const response = await getFixtures(await newClient(), {league: leagueId, next: UPCOMING_FIXTURES})
    return response?.response || []
}
